import { Card, Typography } from 'antd'
import Container from 'components/Container'
import styled, { css } from 'styled-components'
import { color, fontSize, margin, padding, screen } from 'theme/mixins'

const Record = styled(Container)<{ $minHeight?: number }>`
	${({ $minHeight }) =>
		$minHeight &&
		css`
			 {
				min-height: ${$minHeight}px;
			}
		`}
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-bottom: ${margin('sm')};

	${screen.gte.xs`
		margin-bottom: 0;
	`}

	.ant-col {
		display: flex;
		align-items: center;

		img {
			max-width: 66px;
			max-height: 35px;
		}

		&:nth-child(2) {
			justify-content: flex-end;
		}

		&:last-child {
			justify-content: flex-end;
		}

		${screen.gte.xs`
			&:nth-child(2) {
				justify-content: flex-start;
			}
		`}
	}
`

const PlanCard = styled(Card)<{ $selected: boolean }>`
	cursor: pointer;

	${({ $selected }) =>
		$selected &&
		css`
			border: 1px solid ${color('primary')};
		`}

	.ant-card-body {
		padding: ${padding('sm')} ${padding('sm')} ${padding('sm')} ${padding('xl')};

		.ant-radio-wrapper {
			position: absolute;
			top: ${padding('sm')};
			left: ${padding('sm')};
		}

		.ant-row {
			margin-top: 6px;
			padding-left: ${padding('xxs')};
			align-items: baseline;
		}

		.ant-col {
			h5.ant-typography {
				margin-bottom: 0;
				line-height: 1;
			}

			span.ant-typography {
				font-size: ${fontSize('sm')};
			}

			&:last-child {
				text-align: right;
			}
		}
	}
`

const PackCard = styled(PlanCard)`
	.ant-card-body {
		.ant-radio-wrapper {
			top: calc(${padding('sm')} - 2px);
		}

		.ant-row {
			margin-top: 5px;
		}
	}
`

const PlanDescription = styled(Typography.Text)`
	white-space: break-spaces;
`

export default { Record, PlanDescription, PlanCard, PackCard }
